import { useEffect, useState } from "react";
import { api } from "../../../../services/api";

export default function useSelectEnnterprise() {
    const [optionsSelect, setOptionsSelect] = useState([]);

    useEffect(() => {
        getGroups();
        return () => {
      
        }
    }, []);
    const getGroups = async () => {
        const { data: list } = await api({ method: "GET", url: "/source/client" });
        const listSelect = [];
        list.map((row) => {
            listSelect.push({ label: row.search_name, id: row.cre_id });
        });
        setOptionsSelect(listSelect);
    };

    return {
        optionsSelect
    }
}